import _t from 'i18n!nls/degree-home';

export const filterOptionValues = {
  All: 'all',
  Deadlines: 'deadlines',
  LiveEvents: 'liveEvents',
  Overdue: 'overdue',
} as const;

export type FilterOptionValuesType = (typeof filterOptionValues)[keyof typeof filterOptionValues];

export const filterOptions: FilterOptionValuesType[] = [
  filterOptionValues.All,
  filterOptionValues.Deadlines,
  filterOptionValues.LiveEvents,
  filterOptionValues.Overdue,
];

export const calendarListFooterId = 'calendar-list-footer';

export const DAY_SIZE = 39;

type ArgsType = {
  date: string;
};
export const calendarDayPhrases = {
  chooseAvailableStartDate: ({ date }: ArgsType) =>
    _t('Choose #{date} as your check-in date. It’s available.', { date }),
  chooseAvailableEndDate: ({ date }: ArgsType) =>
    _t('Choose #{date} as your check-out date. It’s available.', { date }),
  chooseAvailableDate: ({ date }: ArgsType) => date,
  dateIsUnavailable: ({ date }: ArgsType) => _t('Not available. #{date}', { date }),
  dateIsSelected: ({ date }: ArgsType) => _t('Selected. #{date}', { date }),
  dateIsSelectedAsStartDate: ({ date }: ArgsType) => _t('Selected as start date. #{date}', { date }),
  dateIsSelectedAsEndDate: ({ date }: ArgsType) => _t('Selected as end date. #{date}', { date }),
};

export const CALENDAR_OPTION_VALUES = {
  GOOGLE: 'google',
  WEBCAL: 'webcal',
} as const;

export type CalendarOptionValuesType = (typeof CALENDAR_OPTION_VALUES)[keyof typeof CALENDAR_OPTION_VALUES];

export const calendarOptions: CalendarOptionValuesType[] = [
  CALENDAR_OPTION_VALUES.GOOGLE,
  CALENDAR_OPTION_VALUES.WEBCAL,
];

export const VISIBILITY_KEY = 'dismissedCalendarSyncNotification.v3';
